export default "__VITE_ASSET__6a78f28c__"